import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1655283755055'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='6327'
    >
        <path
            d='M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m198.8608 546.2016l-111.0016 263.9872L400.7936 409.6l-74.9568 136.8064H136.6016v-68.608h148.8896l118.3744-215.8592L593.92 646.144l70.656-168.3456h222.8224v68.4032z'
            p-id='6328'
            fill='currentColor'
        ></path>
    </svg>
)

export const ReceiverIcon = props => <Icon component={SVG} {...props} />
